var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgUserCircle = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true",
  focusable: "false",
  viewBox: "0 0 24 24",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M12 .022C18.615.022 23.978 5.385 23.978 12c0 6.615-5.363 11.978-11.978 11.978C5.384 23.978.02 18.615.02 12 .021 5.385 5.384.022 12 .022ZM9.609 16.02l-3.092 1.772a2.63 2.63 0 0 0-1.325 2.285v.536A10.932 10.932 0 0 0 12 22.978a10.93 10.93 0 0 0 6.791-2.352v-.548a2.63 2.63 0 0 0-1.325-2.285l-3.094-1.771a4.647 4.647 0 0 1-2.38.652c-.87 0-1.686-.238-2.383-.653Zm2.39-15C5.938 1.022 1.022 5.938 1.022 12c0 3.018 1.218 5.751 3.189 7.736a3.624 3.624 0 0 1 1.81-2.81l2.726-1.565A4.662 4.662 0 0 1 7.321 12V9.913a4.673 4.673 0 0 1 4.67-4.674 4.673 4.673 0 0 1 4.672 4.674V12c0 1.32-.548 2.513-1.428 3.363l2.727 1.562a3.63 3.63 0 0 1 1.814 2.824A10.943 10.943 0 0 0 22.978 12c0-6.063-4.915-10.978-10.978-10.978Zm-.007 5.218A3.673 3.673 0 0 0 8.32 9.913V12a3.673 3.673 0 0 0 3.67 3.674A3.673 3.673 0 0 0 15.664 12V9.913a3.673 3.673 0 0 0-3.671-3.674Z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgUserCircle);
export default ForwardRef;